import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class CompleteClaimDto {
  @Field(t => Int)
  claimId!: number

  public constructor (data: CompleteClaimDto) {
    Object.assign(this, data)
  }
}
